import Enum from "../../../../../../enums/Enum";

const ThermalTherapyEnum = new Enum({
    Hot: {name: "Hot"},
    Cold: {name: "Cold"}
});

export default ThermalTherapyEnum;